'use client';

import { createContext, useContext, useEffect, type ReactNode } from 'react';
import type { AnalyticsService } from '@/lib/analytics/types';
import { analytics } from '@/lib/analytics/posthog-client';
import { getConsentStatus } from '@/lib/analytics/consent';

const AnalyticsContext = createContext<AnalyticsService | undefined>(undefined);

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const consent = getConsentStatus();
    if (consent === 'denied') {
      analytics.optOut();
    }
  }, []);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics(): AnalyticsService {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
}
